import { useTranslation } from "react-i18next";
import "./AnswerDisclaimer.css";

/** Liability notice and answer status stored with the answer (Norma features 1
 * and 5). Both are data from the backend — the disclaimer text is per-workspace
 * config, the status is the stored answer status — never wording or logic
 * owned by the UI. A plain "complete" answer shows no status badge. */
export default function AnswerDisclaimer({ text, status }) {
  const { t } = useTranslation();
  const hasText = Boolean(text && text.trim());
  const showStatus = Boolean(status) && status !== "complete";
  if (!hasText && !showStatus) return null;
  return (
    <div className="answer-disclaimer" role="note">
      {showStatus && (
        <span className={`answer-status answer-status--${status}`} data-testid="answer-status"
              data-status={status}>
          {t(`answerStatus.${status}`, { defaultValue: status })}
        </span>
      )}
      {hasText && text}
    </div>
  );
}
